import { createSlice } from '@reduxjs/toolkit';

import type { AuthFailurePopupSchema } from '../types/auth-failure-popup.schema';

const initialState: AuthFailurePopupSchema = {
    isOpen: false,
};

export const authFailurePopupSlice = createSlice({
    name: 'authFailurePopup',
    initialState,
    reducers: {
        showPopup: (state) => {
            state.isOpen = true;
        },
        hidePopup: (state) => {
            state.isOpen = false;
        },
    },
});

export const {
    actions: authFailurePopupActions,
    reducer: authFailurePopupReducer,
} = authFailurePopupSlice;
